import * as React from 'react';
import type { SVGProps } from 'react';
const SvgHorizontalBars = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={297}
    height={252}
    fill="none"
    viewBox="0 0 33 28"
    {...props}
  >
    <path
      fill="var(--color-content-status-neutral-secondary)"
      fillRule="evenodd"
      d="M9.53 4.226v4.74h6.248c.748 0 1.355-.606 1.355-1.354V5.58c0-.748-.607-1.354-1.355-1.354zm0 7.45v4.741h10.506c.748 0 1.354-.607 1.354-1.355V13.03c0-.748-.606-1.354-1.354-1.354zm0 7.451v4.741h13.243c.748 0 1.354-.606 1.354-1.354v-2.032c0-.749-.606-1.355-1.354-1.355z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgHorizontalBars;
